export const formatPriceINR = (n) => {
  if (n == null || Number.isNaN(n)) return "—";
  const v = Number(n);
  if (v >= 10000000) return `₹ ${(v / 10000000).toFixed(2)} Cr`;
  if (v >= 100000) return `₹ ${(v / 100000).toFixed(2)} L`;
  return `₹ ${v.toLocaleString("en-IN")}`;
};

export const formatKm = (km) => {
  if (km == null || Number.isNaN(km)) return "—";
  return `${Number(km).toLocaleString("en-IN")} km`;
};

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const buildWhatsAppLink = (rawNumber, message) => {
  const num = (rawNumber || "").replace(/[^0-9]/g, "");
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${num}?text=${text}`;
};

export const resolveImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};

export const coverImage = (vehicle) => {
  if (!vehicle?.images?.length) return null;
  const cover = vehicle.images.find((i) => i.is_cover) || vehicle.images[0];
  return resolveImageUrl(cover.url);
};

export const calcEMI = (principal, annualRate, tenureMonths) => {
  const P = Number(principal) || 0;
  const R = (Number(annualRate) || 0) / 12 / 100;
  const N = Number(tenureMonths) || 0;
  if (!P || !N) return { emi: 0, total: 0, interest: 0 };
  if (R === 0) return { emi: P / N, total: P, interest: 0 };
  const emi = (P * R * Math.pow(1 + R, N)) / (Math.pow(1 + R, N) - 1);
  const total = emi * N;
  return { emi, total, interest: total - P };
};
